import React from "react";
import plans from "../constants/PricingPlans";  // import plans constant here

// Optional subheader for popular plan
function MostPopularHeader() {
  return (
    <div className="absolute top-0 left-0 w-full py-1 bg-[#FF822C] rounded-t-xl text-center text-xs font-bold text-white">
      Most Popular
    </div>
  );
}

export default function PricingDialog({ onClose, onSubscribe, onGetStarted }) {
  function PricingCard({ plan, isPopular }) {
    return (
      <div
        className={`relative bg-white rounded-xl shadow-xl border border-gray-200 flex flex-col items-center px-4 py-8 transition-transform duration-200 group hover:-translate-y-1 max-w-sm w-full ${
          isPopular ? "z-10" : ""
        }`}
      >
        {isPopular && <MostPopularHeader />}
        <h3 className="text-lg font-semibold mb-3">{plan.type}</h3>
        <div className="flex items-end mb-1">
          <span className="text-3xl font-bold text-gray-900">{plan.price}</span>
          <span className="text-xs ml-2 text-gray-500">{plan.period}</span>
        </div>
        {plan.details && (
          <div className="text-xs text-orange-500 mb-2">{plan.details}</div>
        )}
        <button
          className={`w-full mt-3 py-2 text-sm rounded-md font-medium transition-all duration-150 shadow-sm ${plan.buttonStyle}`}
          style={{ minHeight: "40px" }}
          onClick={plan.type === "Free" ? onGetStarted : onSubscribe}
        >
          {plan.button}
        </button>
        <ul className="list-none mt-6 space-y-2 w-full text-gray-700 text-left text-[0.93rem] font-medium">
          {plan.features.map((feat, idx) => (
            <li key={idx} className="flex items-center gap-2">
              <span className="text-base text-[#17b970] font-extrabold">✓</span>
              <span>{feat}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40"
        onClick={onClose}
      ></div>

      {/* Dialog container */}
      <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-xl shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto p-6 relative">
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition"
            aria-label="Close dialog"
          >
            &#x2715;
          </button>

          {/* Header */}
          <h2 className="text-2xl font-bold mb-6 text-center">
            Choose Your Plan
          </h2>

          {/* Cards container */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {plans.map((plan) => (
              <PricingCard
                key={plan.type}
                plan={plan}
                isPopular={plan.highlight}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
